import { GAME_MODES } from '../game/modes';
import type { GameModeId } from '../game/types';

interface ModePickerProps {
  legend: string;
  selectedMode: GameModeId;
  onSelect: (mode: GameModeId) => void;
  showDescription?: boolean;
}

export function ModePicker({ legend, selectedMode, onSelect, showDescription = true }: ModePickerProps) {
  const selectedDefinition = GAME_MODES.find((mode) => mode.id === selectedMode) ?? GAME_MODES[0];

  return (
    <fieldset className="mode-picker">
      <legend>{legend}</legend>
      <div className="mode-grid">
        {GAME_MODES.map((mode) => (
          <button
            key={mode.id}
            type="button"
            className={`mode-card${selectedMode === mode.id ? ' mode-card--selected' : ''}`}
            onClick={() => onSelect(mode.id)}
            aria-pressed={selectedMode === mode.id}
          >
            <span className="mode-card__check" aria-hidden="true">{selectedMode === mode.id ? '●' : '○'}</span>
            <span><strong>{mode.name}</strong><small>{mode.shortDescription}</small></span>
          </button>
        ))}
      </div>
      {showDescription && <p className="mode-description">{selectedDefinition.description}</p>}
    </fieldset>
  );
}
